export const FETCH_PBI_INIT = 'FETCH_PBI_INIT';
export const FETCH_PBI_SUCCESS = 'FETCH_PBI_SUCCESS';
export const FETCH_PBI_ERROR = 'FETCH_PBI_ERROR';
